import { TooltipValueType } from "recharts";
import { AggregateSeries } from "../trendSeries";

/**
 * Shared by `ThroughputChart` and `BacklogChart` so the two full-size charts
 * cannot silently drift apart in axis styling, time labelling, or prop shape.
 *
 * Neither chart downsamples its data — deliberately: 288 points is
 * unremarkable for a Recharts chart, and there are exactly two instances on
 * the page rather than forty, so decimating would discard real points for no
 * gain and could contradict the coverage note, which reads `minTenants` from
 * the full series rather than whatever the chart happens to draw. The
 * sparkline still downsamples — forty instances at 120px wide is a
 * genuinely different trade.
 */

export const AXIS = { stroke: "#cccccc", fontSize: 9.5 };

export function timeLabel(at: number): string {
    return new Date(at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

/**
 * Every numeric cell on this page uses `.toLocaleString()` — `Measured`,
 * `SummaryBand`, the table's totals footer, the sparkline's tooltip — so the
 * chart tooltip must match rather than showing Recharts' default bare digits.
 * Locale-aware, no explicit locale argument, matching that phase 1 decision.
 *
 * Recharts already filters `null`/`undefined` out before a formatter runs,
 * and `TooltipValueType` also admits string and array values our own data
 * never produces, which is why this narrows instead of calling
 * `.toLocaleString()` unconditionally.
 */
export function formatTooltipValue(value: TooltipValueType | undefined): TooltipValueType | undefined {
    return typeof value === "number" ? value.toLocaleString() : value;
}

export interface iAggregateChartProps {
    data: AggregateSeries;
    /** Fixed width. Omit to fill the container. Tests must pass one: jsdom measures zero. */
    width?: number;
    height?: number;
}
